export const getMarketingPrograms = `query {
  getMarketingPrograms {
    id
    coachId
    coach{
        userId
        name
        email
        picture
    }
    duration{
        interval
        period
    }
    name
    description
    image
    type
    app
    gradient
    isFeatured
    isFree
    payment
    category
    tags
    shortDescription
    status
  }
}`;
